import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Heading.scss';

const Heading = (props) => {
  const {
    className,
    dark,
    primary,
    secondary,
    tertiary,
    regular,
    children,
    center,
    as,
    styleAs,
    style,
  } = props;

  const classes = {
    heading: true,
    [styleAs || as]: true,
    dark,
    primary,
    secondary,
    tertiary,
    regular,
    center,
  };

  switch (as) {
    case 'h4':
      return (
        <h4 style={style} className={classNames(classes, className)}>
          {children}
        </h4>
      );
    case 'h3':
      return (
        <h3 style={style} className={classNames(classes, className)}>
          {children}
        </h3>
      );
    case 'h2':
      return (
        <h2 style={style} className={classNames(classes, className)}>
          {children}
        </h2>
      );
    case 'h1':
    default:
      return (
        <h1 style={style} className={classNames(classes, className)}>
          {children}
        </h1>
      );
  }
};

Heading.defaultProps = {
  className: null,
  as: 'h1',
  styleAs: null,
  primary: false,
  secondary: false,
  tertiary: false,
  regular: false,
  children: null,
  center: false,
  dark: false,
  style: {},
};

Heading.propTypes = {
  className: PropTypes.string,

  style: PropTypes.shape({}),

  /** Render as h1, h2, h3 or h4 element */
  as: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4']),

  /** Render as h1, h2, h3 or h4 style */
  styleAs: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4']),

  /** Theme dark */
  dark: PropTypes.bool,

  /** Style primary */
  primary: PropTypes.bool,

  /** Style secondary */
  secondary: PropTypes.bool,

  /** Style tertiary */
  tertiary: PropTypes.bool,

  /** Weight regular */
  regular: PropTypes.bool,

  /** text align center */
  center: PropTypes.bool,
  children: PropTypes.node,
};

export default Heading;
